<template>
<div class="vh-100">
   <AppHeader></AppHeader>
 <router-view></router-view>
  
</div>
  
 
</template>

<script>

import AppHeader from '@/components/appShared/appHeader.vue'
export default {
  name: 'App',
 components:{
    AppHeader
}
}
</script>

<style scoped>

</style>
